import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpClientJsonpModule } from '@angular/common/http';
import { Observable, Subject, asapScheduler, pipe, of, from, interval, merge, fromEvent, empty } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, catchError, map, retry, timeout, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class MainService {
  base: string = environment.datasServer;

  timeoutDelay: number = 5000;
  retryNb: number = 10;

  datas: any;



  headers = new Headers({
    'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
    'Pragma': 'no-cache',
    'Expires': '0'
  });


  constructor(
    private httpClient: HttpClient
  ) {
    // console.log(environment);
    //
    // this.datasName = this.findGetParameter('datas');
    // console.log("this.datasName", this.datasName);


    // si dév > http://localhost:8080/apps/dev/int-marcelle/dist/?datas=bacteries
    // call http://localhost:8080/apps/datas/bacteries/datas.json

    // si prod > http://localhost:8080/apps/dev/int-marcelle/dist/?datas=bacteries
    // call http://localhost:8080/apps/datas/bacteries/datas.json


    // this.base = 'http://192.168.0.123:80/apps/datas/';
    // this.base = 'https://expo-intelligence.org/apps/datas/';
    // this.base = '../../../datas/';
  }

  public loadDatasName(): Observable<any> {
    let rnd = Math.round(9999999999999 * Math.random());
    return this.httpClient.get<any>(this.base + "select.txt?" + rnd, { responseType: 'text' as 'json' })
      .pipe(
        timeout(this.timeoutDelay),
        retry(this.retryNb),
        catchError((err, caught) => this.handleErrorObservable(err, caught))
      );
  }
  public loadDatas(datasName: string): Observable<any> {
    let rnd = Math.round(9999999999999 * Math.random());
    return this.httpClient.get<any>(this.base + datasName + "/datas.json?" + rnd)
      .pipe(
        timeout(this.timeoutDelay),
        retry(this.retryNb),
        catchError((err, caught) => this.handleErrorObservable(err, caught))
      );
  }
  public loadDatasDev(datasName: string): Observable<any> {
    let rnd = Math.round(9999999999999 * Math.random());
    return this.httpClient.get<any>(this.base + datasName + "/datasdev.json?" + rnd)
      .pipe(
        timeout(this.timeoutDelay),
        retry(this.retryNb),
        catchError((err, caught) => this.handleErrorObservable(err, caught))
      );
  }
  public loadVideoFolders(datasName:string): Observable<any> {
    let rnd = Math.round(9999999999999*Math.random());
    return this.httpClient.get<any>(this.base+datasName+"/videos.json?"+rnd)
      .pipe(
        timeout(this.timeoutDelay),
        retry(this.retryNb),
        catchError((err, caught) => this.handleErrorObservable(err, caught))
      );
  }

  public loadStory(datasName: string, lang:number = 0): Observable<any> {
    let rnd = Math.round(9999999999999 * Math.random());
    let langStr = '';
    if (lang == 1){
      langStr = 'en'; 
    }
    return this.httpClient.get<any>(this.base + datasName + "/filesdev/story"+langStr+".json?" + rnd)
      // return this.httpClient.get<any>('https://expooo.plus/apps/cron/stories/94920.json' + '?' + rnd)
      .pipe(
        timeout(this.timeoutDelay),
        retry(this.retryNb),
        catchError((err, caught) => this.handleErrorObservable(err, caught)),
        tap((datas) => {
          datas.lang = lang;
          return datas;
        })
        );
      }
      
  public loadInkleWriter(jsonUrl: string, lang:number = 0): Observable<any> { //94920
    let rnd = Math.round(9999999999999 * Math.random());
    let url = 'https://www.expooo.plus/apps/proxy/index.php?endpoint=' + jsonUrl;
    console.log(url);
    return this.httpClient.jsonp<any>(url, 'callback') //  + "?" + rnd
    .pipe(
      timeout(this.timeoutDelay),
      retry(this.retryNb),
      catchError((err, caught) => this.handleErrorObservable(err, caught)),
      tap((datas) => {
        datas.lang = lang;
        return datas;
      })
    );
  }

  public loadMedia(mediaUrl: string): Observable<Blob> {
    return this.httpClient.get(mediaUrl, { responseType: 'blob' });
  }
  public loadText(url: string): Observable<any> {
    let rnd = Math.round(9999999999999 * Math.random());
    return this.httpClient.get<any>(url + '?' + rnd, { responseType: 'text' as 'json' })
      .pipe(
        timeout(this.timeoutDelay),
        retry(this.retryNb),
        catchError((err, caught) => this.handleErrorObservable(err, caught))
      );
  }

  private handleErrorObservable(error: any, caught: any): Observable<any> {
    if (error.status == "401") {
      console.log("Erreur 401 : Accès refusé, redirection en cours");
      // this.router.navigate(['/dashboard']);
    } else {
      console.error("json mal formaté ou introuvable :", error); // for demo purposes only
    }
    return empty();
  }

  public loadDatasLocal(datasName: string): Observable<any> {
    let rnd = Math.round(9999999999999 * Math.random());
    return this.httpClient.get<any>(this.base + '../local/' + datasName + "/datas.json?" + rnd)
      .pipe(
        timeout(this.timeoutDelay),
        retry(this.retryNb),
        catchError((err, caught) => this.handleErrorObservable(err, caught))
      );
  }

  public writeDatasLocal(datasName: StringConstructor, datas: any): Observable<any> {
    let rnd = Math.round(9999999999999 * Math.random());
    return this.httpClient.post<any>(this.base + '../local/write.php?datas='+datasName, datas )
      .pipe(
        timeout(this.timeoutDelay),
        retry(this.retryNb),
        catchError((err, caught) => this.handleErrorObservable(err, caught))
      );
  }


}
